import React, { useState } from "react";
import { Table, Collapse, TableRow, TableCell } from "@mui/material";
import { useFormContext } from "react-hook-form";

import { ROUTINGS as OPTIONS } from "../../constants";
import RoutingTableRow from "./RoutingTableRow";

const RoutingHiddenRows = () => {
  const [open, setOpen] = useState(false);
  const onClick = () => setOpen(!open);

  const { watch } = useFormContext();
  const routings = watch("routings") || [];
  const hidden = OPTIONS?.filter((route) => !routings?.includes(route.id));

  const sx = open
    ? { ":hover": { backgroundColor: "transparent !important" }, width: "100%" }
    : { border: "none" };

  return (
    <>
      <TableRow onClick={onClick}>
        <TableCell colSpan={3}>{open ? "Hide" : "Show Hidden"} </TableCell>
      </TableRow>
      <TableRow sx={sx}>
        <TableCell colSpan={3} sx={{ padding: "0px !important" }}>
          <Collapse in={open}>
            <Table sx={{ border: "none !important" }}>
              {hidden?.map((route) => (
                <RoutingTableRow key={route.id} route={route} />
              ))}
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default RoutingHiddenRows;
